"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenManager = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const constants_1 = require("./common/constants");
const functions_1 = require("./common/functions");
class TokenManager {
    /**
     * Gets the FIT access_token from session storage.
     * @return the access_token.
     */
    static getAccessToken() {
        return sessionStorage.getItem(constants_1.SESSION_STORAGE_ACCESS_TOKEN_KEY);
    }
    /**
     * Gets the FIT id_token from session storage.
     * @return the id_token.
     */
    static getIdToken() {
        return sessionStorage.getItem(constants_1.SESSION_STORAGE_ID_TOKEN_KEY);
    }
    /**
     * Gets the FIT refresh_token from session storage.
     * @return the refresh_token.
     */
    static getRefreshToken() {
        return sessionStorage.getItem(constants_1.SESSION_STORAGE_REFRESH_TOKEN_KEY);
    }
    /**
     * Sets the FIT access_token in session storage.
     *
     * @param token the value for the token.
     */
    static setAccessToken(token) {
        sessionStorage.setItem(constants_1.SESSION_STORAGE_ACCESS_TOKEN_KEY, token);
    }
    /**
     * Sets the FIT id_token in session storage.
     *
     * @param token the value for the token.
     */
    static setIdToken(token) {
        sessionStorage.setItem(constants_1.SESSION_STORAGE_ID_TOKEN_KEY, token);
    }
    /**
     * Sets the FIT refresh_token in session storage.
     *
     * @param token the value for the token.
     */
    static setRefreshToken(token) {
        sessionStorage.setItem(constants_1.SESSION_STORAGE_REFRESH_TOKEN_KEY, token);
    }
    /**
     * Gets a claim from the token.
     *
     * @param token The token from which to get the claim.
     * @param key The name of the claim.
     * @return the value of the claim.
     */
    static getTokenClaim(token, key) {
        return (0, jwt_decode_1.default)(token)[key];
    }
    /**
     * Checks if all three FIT tokens exist in session storage.
     * @return {@code true} if tokens exist; otherwise, {@code false}.
     */
    static tokensExist() {
        return !(0, functions_1.isEmptyString)(this.getAccessToken())
            && !(0, functions_1.isEmptyString)(this.getIdToken())
            && !(0, functions_1.isEmptyString)(this.getRefreshToken());
    }
}
exports.TokenManager = TokenManager;
//# sourceMappingURL=tokenManager.js.map